var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorPage',{attrs:{"code":"204","status":"No Content","message":"Screen size is too small.","href-text":"Go to Drivetrain Hub","href":_vm.$urls.SITE_HOME,"refresh-link":true}})}
var staticRenderFns = []

export { render, staticRenderFns }